import { render, staticRenderFns } from "./fanmadeLive2d.vue?vue&type=template&id=4c27880a&scoped=true"
import script from "./fanmadeLive2d.vue?vue&type=script&lang=js"
export * from "./fanmadeLive2d.vue?vue&type=script&lang=js"
import style0 from "./fanmadeLive2d.vue?vue&type=style&index=0&id=4c27880a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27880a",
  null
  
)

export default component.exports